import styled from "styled-components";

export const IconPickerContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const ICON_TILE_SIZE = 56;
const ICON_GRID_GAP = 8;
const ICON_GRID_COLUMNS = 5;
const ICON_GRID_VISIBLE_ROWS = 4;

const ICON_GRID_SCROLLBAR_SPACE = 10;
const ICON_GRID_MAX_WIDTH = ICON_GRID_COLUMNS * ICON_TILE_SIZE + (ICON_GRID_COLUMNS - 1) * ICON_GRID_GAP + ICON_GRID_SCROLLBAR_SPACE;

export const IconGrid = styled.div<{ $error: boolean }>`
    display: grid;
    grid-template-columns: repeat(auto-fill, ${ICON_TILE_SIZE}px);
    grid-auto-rows: ${ICON_TILE_SIZE}px;
    gap: ${ICON_GRID_GAP}px;
    width: 100%;
    max-width: ${ICON_GRID_MAX_WIDTH}px;
    max-height: ${ICON_GRID_VISIBLE_ROWS * ICON_TILE_SIZE + (ICON_GRID_VISIBLE_ROWS - 1) * ICON_GRID_GAP}px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: ${ICON_GRID_SCROLLBAR_SPACE}px;
    border-radius: 8px;
    box-shadow: ${({ $error }) => ($error ? "0 0 0 1px #ff4d4f" : "none")};

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-thumb {
        background: #d0d0d0;
        border-radius: 3px;
    }
`;

export const IconItem = styled.button<{ $selected: boolean }>`
    width: 56px;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ $selected }) => ($selected ? "#ebebeb" : "transparent")};
    border: none;
    border-radius: 8px;
    cursor: pointer;
    padding: 0;
    outline: none;
    transition: background 0.15s ease, transform 0.15s ease;

    &:hover:not(:disabled) {
        background: ${({ $selected }) => ($selected ? "#e2e2e2" : "#f3f3f3")};
    }

    &:active:not(:disabled) {
        transform: scale(0.94);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
    }
`;

export const IconGlyph = styled.span<{ $src: string }>`
    width: 32px;
    height: 32px;
    display: block;
    color: #000;
    background-color: currentColor;
    -webkit-mask: url(${({ $src }) => $src}) center / contain no-repeat;
    mask: url(${({ $src }) => $src}) center / contain no-repeat;
`;
